import { useBrand } from "../context/SettingsContext";

export const BrandMark = ({ dark = false, testId = "brand-mark" }) => {
  const { brand } = useBrand();
  if (brand.logo)
    return <img data-testid={testId} src={brand.logo} alt={brand.trading_name} className="h-9 w-auto max-w-[180px] object-contain" />;
  return (
    <div data-testid={testId} className="flex items-center gap-2">
      <span className="grid h-9 w-9 place-items-center rounded-md bg-red-600 font-display text-lg font-bold text-white">M</span>
      <span className={`hidden font-display text-xl font-bold uppercase tracking-wide sm:inline ${dark ? "text-white" : "text-zinc-900"}`}>
        {brand.trading_name || "MAG Installations"}
      </span>
    </div>
  );
};
